import React, {useEffect, useState} from 'react';
import {PanelWrapper} from "../../../components";
import {Link, useParams} from "react-router-dom";
import UserCard from "../../../components/user-card/user-card";
import {Alert} from "../../../core-ui";
import {fetchData} from "../../../helpers/general-function";

const MyRequests = () => {

    const {shift_request_id} = useParams();

    const [shiftInfo, setShiftInfo] = useState({});

    useEffect(() => {
        (async () => {
            const data = await fetchData(`panel/shift-requests/info/${shift_request_id}`, 'get', {}, true);

            if (data) {
                setShiftInfo(data);
            }
        })();
    }, []);

    return (
        <PanelWrapper activeRouteData={{icon: 'icon-clipboard-tick-2', name: 'شیفت های قبول شده'}}>
            <div className='text-start d-none d-lg-block'>
                <Link to='/panel/my-shifts' className='c-link-gray'>
                    بازگشت به صفحه نخست
                    <div className='d-inline-block me-2' style={{transform: 'rotateZ(180deg)'}}>
                        <i className='icon-arrow-circle-right align-middle'/>
                    </div>
                </Link>
            </div>
            <div className='mt-4'>
                <div className='text-center'>
                    <Alert className='m-auto'
                           alertClassName={shiftInfo.employer_info ? 'icon-tick-circle' : 'icon-close-circle'}/>
                    <h2 className={`${shiftInfo.employer_info ? 'success-color' : 'dark-danger-color'} mt-c-2_5 mt-lg-4`}>
                        {shiftInfo.employer_info ? 'درخواست شما با موفقیت پذیرفته شده است.' : 'درخواست در انتظار تایید از سمت کارفرما است'}
                    </h2>
                    {
                        shiftInfo.employer_info &&
                        <p className='gray-color'>برای هماهنگی‌های بیشتر می‌توانید با کارفرما در ارتباط
                            باشید.</p>
                    }

                </div>
                <div className='mt-5 mt-lg-c-5 col-12 col-sm-8 col-md-6 col-lg-7 col-xl-6 mx-auto'>
                    {
                        shiftInfo.employer_info &&
                        <>
                            <h4 className='fs-c-3 success-color text-center mb-4'>اطلاعات کارفرما :</h4>
                            <UserCard
                                name={shiftInfo.employer_info?.name}
                                type={shiftInfo.employer_info?.type === 'student' ? 'دانشجو' : 'داروساز'}
                                status={null}
                                descChildren={
                                    <div className='mt-3 rtl'>
                                        <p className='fs-c-6 success-color'>{shiftInfo.employer_info?.mean_rate}%<i
                                            className='icon-heart-2 ms-2 align-middle'/> میزان رضایت</p>
                                    </div>
                                }
                                image_source='http://www.best4geeks.com/wp-content/uploads/2018/12/4.-awesome-profile-pic-1.jpg'>
                                <div className='d-flex justify-content-center mt-4'>
                                    <a href={`tel:${shiftInfo.employer_info.mobile}`} className='c-btn simple-btn-success flex-grow-1 flex-md-grow-0 ps-5 text-center position-relative'>
                                        <i className='icon-call call me-auto align-middle icon-color-white'/>
                                        {shiftInfo.employer_info.mobile}
                                    </a>
                                </div>
                            </UserCard>
                        </>
                    }
                </div>
            </div>
        </PanelWrapper>
    );
};

export default MyRequests;
